import { gql } from "@apollo/client";

export default gql`
  mutation RemoveInvitee($targetId: String!, $targetType: String!, $inviteeId: ObjectId!) {
    removeInvitee(targetId: $targetId, targetType: $targetType, inviteeId: $inviteeId)
  }
`;
